export const deckTextColorOptions = [
  { value: '', labelKey: 'deckDetails.textColors.default' },
  { value: '#000000', labelKey: 'deckDetails.textColors.black' },
  { value: '#ffffff', labelKey: 'deckDetails.textColors.white' },
  { value: '#6b7280', labelKey: 'deckDetails.textColors.gray' },
  { value: '#1e3a8a', labelKey: 'deckDetails.textColors.darkBlue' },
  { value: '#dc2626', labelKey: 'deckDetails.textColors.red' },
  { value: '#16a34a', labelKey: 'deckDetails.textColors.green' },
  { value: '#facc15', labelKey: 'deckDetails.textColors.gold' },
  { value: '#7c3aed', labelKey: 'deckDetails.textColors.purple' },
  { value: '#14b8a6', labelKey: 'deckDetails.textColors.teal' },
];

export const getDeckCardTextStyle = (textColor) => (
  textColor ? { '--deck-card-text-color': textColor } : undefined
);
